<!--
  File Name: Verify.vue
  Description: Verify Page
-->

<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/Login.svg"
                alt="login"
                class="mx-auto"
                width="150px"
              />
            </div>

            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              v-if="!isUpdate"
            >
              <div class="p-8">
                <form
                  @submit.prevent="verify"
                  @keydown="form.onKeydown($event)"
                >
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">{{ $t("verify.labels.set_password") }}</h4>
                  </div>

                  <vs-input
                    :class="{ 'is-invalid': form.errors.has('password') }"
                    class="w-full mt-6 no-icon-border"
                    icon-pack="feather"
                    icon="icon icon-lock"
                    :label-placeholder="$t('verify.labels.password')"
                    name="password"
                    type="password"
                    v-model="form.password"
                  />
                  <has-error :form="form" field="password" />

                  <vs-input
                    :class="{
                      'is-invalid': form.errors.has('password_confirmation'),
                    }"
                    class="w-full mt-6 no-icon-border"
                    icon-pack="feather"
                    icon="icon icon-lock"
                    :label-placeholder="$t('verify.labels.password_confirm')"
                    name="password_confirmation"
                    type="password"
                    v-model="form.password_confirmation"
                  />
                  <has-error :form="form" field="password_confirmation" />
                  <div class="flex flex-wrap justify-end my-5">
                    <vs-button
                      v-if="activationType == 'account'"
                      button="submit"
                    >
                      {{ $t("verify.actions.activate_user") }}
                    </vs-button>
                    <vs-button v-else button="submit">
                      {{ $t("verify.actions.confirm_email") }}
                    </vs-button>
                  </div>
                </form>
              </div>
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              v-else
            >
              <div class="p-8">
                <form
                  @submit.prevent="verify"
                  @keydown="form.onKeydown($event)"
                >
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">
                      {{ $t("verify.actions.confirm_email_change") }}
                    </h4>
                  </div>
                  <div class="flex flex-wrap justify-center my-5 mb-20 mt-20">
                    <vs-button button="submit">
                      {{ $t("verify.actions.confirm_email_change") }}
                    </vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Form from 'vform'
import Swal from 'sweetalert2'

export default {
  data: () => ({
    form: new Form({
      password_confirmation: '',
      password: '',
      expires: '',
      token: ''
    }),
    computed: {},
    remember: false,
    isUpdate: false,
    activationType: 'email'
  }),
  beforeMount() {
    this.isUpdate = Boolean(parseInt(this.$route.query.updated))
    this.activationType = this.$route.query.type
  },
  methods: {
    async verify() {
      const vm = this
      this.$vs.loading({ container: '.vx-card' })
      try {
        const {updated, signature } = this.$route.query
        const params = {
          updated,
          signature
        }
        const user = this.$route.params.id

        const paramsEncode = new URLSearchParams(params).toString()
        const vm = this

        const data = await vm.form
          .post(
            `${process.env.VUE_APP_API_URL}/api/email/verify/${user}?${paramsEncode}`
          )
          .then(function (response) {
            if (response.data.status == 'verification.verified') {
              const titleMessage =
                vm.activationType == 'account'
                  ? 'success_activate'
                  : 'success_verify'

              Swal.fire({
                icon: 'success',
                title: vm.$t(`verify.messages.${titleMessage}`),
                text: vm.$t(`verify.messages.${titleMessage}_description`),
                reverseButtons: true,
                allowOutsideClick: false,
                confirmButtonText: vm.$t('ok'),
                cancelButtonText: vm.$t('cancel')
              }).then(() => {
                vm.$router.push({ name: 'login' })
              })
            }
          })
          .catch(function (error) {
            vm.$vs.loading.close('.vx-card > .con-vs-loading')
            const response = !_.isUndefined(error.response.data)
              ? error.response.data
              : undefined

            if (response.status == 'verification.already_verified') {
              Swal.fire({
                icon: 'warning',
                title: vm.$t('verify.errors.already_verify'),
                text: vm.$t('verify.errors.already_verify_description'),
                reverseButtons: true,
                allowOutsideClick: false,
                confirmButtonText: vm.$t('ok'),
                cancelButtonText: vm.$t('cancel')
              }).then(() => {
                vm.$router.push({ name: 'login' })
              })
            }
          })

        vm.$vs.loading.close('.vx-card > .con-vs-loading')
      } catch (exception) {
        vm.$vs.loading.close('.vx-card > .con-vs-loading')
        console.log('Ocurrió un error:', exception)
      }
    }
  },
  metaInfo() {
    return {
      title:
        this.activationType == 'account'
          ? 'Activar usuario'
          : 'Confirmar email'
    }
  }
}
</script>
